import { AfterViewInit, Component, EventEmitter, Inject, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { Container } from 'app/models/container.model';
import { ContainerService } from 'app/services/container.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericMapComponent } from '../../generic-map/generic-map.component';


@Component({
    selector: 'container-detail',
    templateUrl: './container-detail.component.html',
    styleUrls: ['./container-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ContainerDetailComponent implements AfterViewInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild('paginatorGeneric') private _paginator: MatPaginator;
    @Output() public done = new EventEmitter();
    
    public operation:'full'|'empty'|'critical'

    private _containers : Array<Container>=[];
    public get containers() : Array<Container> {
        return this._containers;
    }
    public set containers(v : Array<Container>) {
        this._containers = v;
    }
    
    private _dataSource: MatTableDataSource<Container> = undefined;
    public get dataSource(): MatTableDataSource<Container> {
        return this._dataSource;
    }

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    private _displayedColumns = ['deviceId','neighbor','street','streetDesc','device.deviceLatestStatus.mesafe','device.deviceLatestStatus.batarya','device.deviceLatestStatus.sonBaglantiTarih','setting'];
    
    constructor(
        private _dialog:MatDialog,
        private _spinner:NgxSpinnerService,
        @Inject(MAT_DIALOG_DATA) private _data: Array<Container>) { }

    async ngAfterViewInit() {
        this._spinner.show('loading')
        this.containers = this._data
        this._spinner.hide('loading')
        await this.updateTableDataSource();
    }

    public async onContainerMap(element){
        const dialog = this._dialog.open(GenericMapComponent,{
        })
        dialog.componentInstance.latitude=element.latitude
        dialog.componentInstance.longitude=element.longitude
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Container>(this.containers);
        this._dataSource.paginator =await this._paginator;
        this._dataSource.sort = this._sort;
    }

}
